<template>
    <div class="grid">
        <div class="col-12">
            <tabela :reorderableRows="dragAndDropEnabled" @rowReorder="onRowReorder" :paginator="false" :mostrarHeader="false" :data="anexosLocal">
                <template #conteudo>
                    <Column v-if="dragAndDropEnabled && this.isAnexosAtivos" rowReorder :reorderableColumn="false" headerStyle="width: 2em">
                        <template>
                            <font-awesome-icon icon="bars" class="custom-reorder-icon hover:cursor-grab" />
                        </template>
                    </Column>
                    <Column headerStyle="width: 3em">
                        <template #body="slotProps">
                            <div class="flex">
                                <font-awesome-icon
                                    v-if="this.isAnexosAtivos && this.dragAndDropEnabled"
                                    icon="minus-circle"
                                    @click="confirmarInativarAnexo(slotProps.data)"
                                    size="lg"
                                    class="icon-button ml-2 p-text-danger"
                                    title="Inativar anexo"
                                />
                                <!-- comentado o código abaixo pois o cliente somente solicitou no dia 24/04/2025, ter somente essa função, caso precise de ativar o documento é só descomentar esse código abaixo -->
                                <!-- <font-awesome-icon v-if="!this.isAnexosAtivos"
                                    icon="check-circle"
                                    @click="confirmarAtivarAnexo(slotProps.data)"
                                    size="lg"
                                    class="icon-button ml-2 p-text-success"
                                    title="Ativar anexo"
                                /> -->
                                <font-awesome-icon
                                    v-if="podeVisualizar(slotProps.data.nomeArquivo)"
                                    icon="search"
                                    @click="abrir(slotProps.data)"
                                    size="lg"
                                    class="icon-button ml-2"
                                    title="Visualizar anexo"
                                />
                                <visualizar-anexo :mostrar="mostrar" :titulo="titulo" @cancelar="fechar()" v-if="slotProps.data">
                                    <iframe v-if="arquivo" :src="arquivo" style="width: 100%; height: 850px"></iframe>
                                </visualizar-anexo>
                                <font-awesome-icon
                                    icon="download"
                                    @click="download(slotProps.data)"
                                    size="lg"
                                    class="icon-button ml-2 p-text-primary"
                                    title="Download"
                                    v-if="slotProps.data"
                                />
                            </div>
                        </template>
                    </Column>
                    <Column header="Nome Arquivo">
                        <template #body="slotProps">
                            {{ slotProps.data.nomeArquivo || 'Sem nome do arquivo' }}
                        </template>
                    </Column>
                    <Column header="Etapa do processo">
                        <template #body="slotProps">
                            {{ slotProps.data.nomeEtapa || 'Sem etapa do processo' }}
                        </template>
                    </Column>
                    <Column header="Tipo documento">
                        <template #body="slotProps">
                            {{ slotProps.data.tipoArquivo || 'Sem tipo do documento' }}
                        </template>
                    </Column>
                    <Column header="Status">
                        <template #body="slotProps">
                            <span>
                                <font-awesome-icon v-if="slotProps.data.status === 1" icon="circle" style="color: blue; margin-right: 5px" />
                                <font-awesome-icon v-else-if="slotProps.data.status === 0" icon="circle" style="color: red; margin-right: 5px" />
                                {{ slotProps.data.status === 1 ? 'Ativo' : 'Inativo' }}
                            </span>
                        </template>
                    </Column>
                </template>
            </tabela>
        </div>
    </div>
</template>

<script>
import VisualizarAnexo from '../VisualizarAnexo.vue';
import SolicitacoesService from '../services';
import 'primeicons/primeicons.css';

export default {
    props: {
        anexos: {
            type: Array,
            required: true,
        },
        isAnexosAtivos: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['carregarAnexos'],
    components: { VisualizarAnexo },
    data() {
        return {
            mostrar: false,
            titulo: '',
            anexosLocal: [...this.anexos],
            arquivo: null,
        };
    },
    computed: {
        dragAndDropEnabled() {
            return this.$temAcessoView('LICITACOES-57');
        },
    },
    watch: {
        anexos(newVal) {
            this.anexosLocal = [...newVal];
        },
    },
    methods: {
        abrir(anexo) {
            this.$store.dispatch('addRequest');
            this.titulo = anexo.nomeArquivo;
            SolicitacoesService.obterAnexo(anexo.documentoId).then((response) => {
                if (response?.success) {
                    const blob = new Blob([response.data], { type: this.getMimeType(anexo.nomeArquivo) });
                    this.arquivo = window.URL.createObjectURL(blob);
                    this.mostrar = true;
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Classificar',
                        detail: 'Erro ao abrir anexo',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
        fechar() {
            if (!this.mostrar) return;
            this.mostrar = false;
        },
        download(anexo) {
            this.$store.dispatch('addRequest');
            SolicitacoesService.obterAnexo(anexo.documentoId).then((response) => {
                if (response?.success) {
                    this.$download(response.data, `${anexo.nomeArquivo}`);
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Classificar',
                        detail: 'Erro ao realizar download do anexo',
                        life: 3000,
                    });
                }
                this.$store.dispatch('removeRequest');
            });
        },
        getMimeType(filename) {
            const lowerCaseFilename = filename.toLowerCase();
            const extension = lowerCaseFilename.slice(lowerCaseFilename.lastIndexOf('.'));
            switch (extension) {
                case '.pdf':
                    return 'application/pdf';
                case '.png':
                    return 'image/png';
                case '.jpeg':
                case '.jpg':
                    return 'image/jpeg';
                case '.doc':
                    return 'application/msword';
                case '.docx':
                    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                case '.xls':
                    return 'application/vnd.ms-excel';
                case '.xlsx':
                    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                default:
                    return 'application/octet-stream';
            }
        },
        podeVisualizar(filename) {
            const lowerCaseFilename = filename.toLowerCase();
            const extension = lowerCaseFilename.slice(lowerCaseFilename.lastIndexOf('.'));
            switch (extension) {
                case '.doc':
                case '.docx':
                case '.xls':
                case '.xlsx':
                case '.zip':
                    return false;
                default:
                    return true;
            }
        },
        onRowReorder(event) {
            this.$store.dispatch('addRequest');

            this.anexosLocal = event.value.map((anexo, index) => ({
                ...anexo,
                posicao: index + 1,
            }));

            SolicitacoesService.atualizarPosicoes(this.anexosLocal)
                .then(() => {
                    this.$toast.add({
                        severity: 'success',
                        summary: 'Reordenado',
                        detail: 'Os anexos foram reordenados com sucesso.',
                        life: 3000,
                    });
                })
                .catch(() => {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Erro',
                        detail: 'Falha ao atualizar a posição dos anexos.',
                        life: 3000,
                    });
                });

            this.$emit('update:anexos', this.anexosLocal);
            this.$store.dispatch('removeRequest');
        },
        pegarEtapaFutura() {
            return this.solicitacao.proximaEtapa;
        },
        verificaSeDeveDesabilitar(etapa, tipoSolicitacao, regra) {
            const etapaFutura = this.pegarEtapaFutura();

            if (etapaFutura != etapa) return true;

            return !(etapaFutura === etapa && this.$temAcessoView(regra));
        },
        confirmarInativarAnexo(anexo) {
            this.$confirm.require({
                message: `Tem certeza que deseja inativar o documento ${anexo.nomeArquivo} ?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.alterarStatusDocumento(anexo.documentoId, false),
            });
        },
        confirmarAtivarAnexo(anexo) {
            this.$confirm.require({
                message: `Tem certeza que deseja ativar o documento ${anexo.nomeArquivo} ?`,
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => this.alterarStatusDocumento(anexo.documentoId, true),
            });
        },
        alterarStatusDocumento(anexoId, isDocumentoAtivo) {
            this.$store.dispatch('addRequest');
            SolicitacoesService.alterarStatusDocumento(anexoId, isDocumentoAtivo).then((response) => {
                const corpoMensagemSucesso = isDocumentoAtivo ? 'Documento ativado com sucesso' : 'Documento inativado com sucesso';
                const cabecalhoMensagem = isDocumentoAtivo ? 'Ativar documento' : 'Inativar documento';
                const corpoMensagemErro = isDocumentoAtivo ? 'Erro ao ativar documento' : 'Erro ao inativar documento';
                if (response?.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: cabecalhoMensagem,
                        detail: corpoMensagemSucesso,
                        life: 3000,
                    });
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: cabecalhoMensagem,
                        detail: corpoMensagemErro,
                        life: 3000,
                    });
                }
                this.$emit('carregarAnexos');
                this.$store.dispatch('removeRequest');
            });
        },
    },
};
</script>
